import { Event } from '../models/event.model';

export const EVENT_DAILY_COST = 5;

// This is a copy of the function in functions/src/stripeCheckout.functions.ts
export const eventCost = (event: Event) => {
  const start = new Date(event.startTime);
  const end = new Date(event.endTime);

  // Normalize to midnight
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const msPerDay = 24 * 60 * 60 * 1000;
  const diffInDays = Math.round((end.getTime() - start.getTime()) / msPerDay);

  return (diffInDays + 1) * EVENT_DAILY_COST;
};
